import { render } from "./ImageText.vue?vue&type=template&id=bcab5f2e"
import script from "./ImageText.vue?vue&type=script&lang=js"
export * from "./ImageText.vue?vue&type=script&lang=js"

import "./ImageText.vue?vue&type=style&index=0&id=bcab5f2e&lang=css"

import exportComponent from "/builds/dalmadima/umzugbayernwebapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__